/* eslint-disable */

function pageParam() {
    var pageParam = new Object()
    pageParam.getUrlKey = getUrlKey
    return pageParam
}

var getUrlKey = function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export {
    pageParam
}


// WEBPACK FOOTER //
// ./src/common/js/pageParam.js